import { createApi } from '@/api/modules/utils'

const baseUrl = '/auto_publish'
const api = createApi(baseUrl)

// 自建站平台详情
export const autoPublishApi = {
    list: api('list', 'get'),
    insert: api('insert', 'post'),
    update: api('update', 'post'),
    delete: api('delete', 'get'),
    detail: api('detail', 'get'),
    detailFlowing: api('detail_flowing', 'get'),
    select: api('select', 'get'),
    upcoming: api('upcoming', 'get'),
}